import _ from 'static/script/libs/underscore';

let current = null;

const initData = {
    current: function () {
        return current ? _.clone(current) : null;
    },
    getForScribe: function () {
        let currentClone = initData.current();
        if (currentClone) {
            delete currentClone.description;
            delete currentClone.viewHtml;
        }
        return currentClone;
    },
    parseHtml: function (html) {
        let initDataString = $(html).find('#init-data').html();
        return initDataString ? JSON.parse(initDataString) : null;
    },
    setFromHtml: function (html) {
        let parsed = initData.parseHtml(html);
        initData.set(parsed);
        return initData.current();
    },
    set: function (val) {
        current = val;
    },
    currentOrSet: function () {
        let c = initData.current();
        if (c !== null) {
            return c;
        }
        return initData.setFromHtml(document.body);
    }
};

module.exports = initData;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/init-data.js